import _ from 'lodash';
import moment from 'moment';
import DepsService from 'services/dependencies';
import { getUsers } from 'user/resources/user.api';
import actionTypes from './action-types';
import * as api from '../resources/retailer-reports.api';

const createCustomFileName = (fileName, date, retailerId, dateFormatShort) => {
  const generateDateString = (date) => moment(date).format(dateFormatShort).replace(/\//g, '-').replace(/\:/g, '');
  const transformFileName = (fileName) => fileName.replace(/\s/g, '_');
  const transformedFileName = transformFileName(fileName);
  const dateString = generateDateString(date);

  if (retailerId) return `${retailerId}_${transformedFileName}_${dateString}`;

  return `${transformedFileName}_${dateString}`;
};

export const fetchRetailerReportsRequest = () => ({
  type: actionTypes.FETCH_RETAILER_REPORTS_REQUEST,
  name: 'retailerReportsLoadingStatus',
});

export const fetchRetailerReportsFailure = () => ({
  type: actionTypes.FETCH_RETAILER_REPORTS_FAILURE,
  name: 'retailerReportsLoadingStatus',
});

export const fetchRetailerReportsSuccess = (items, pagination) => ({
  type: actionTypes.FETCH_RETAILER_REPORTS_SUCCESS,
  items,
  pagination,
  name: 'retailerReportsLoadingStatus',
});

export const fetchRetailerReports = (parameters) => async (dispatch, getState) => {
  try {
    const { session, config } = getState();
    const { dateFormatShort } = config;
    const { locale, retailer = {} } = session;
    const { retailerId, retailerDisplayNumber } = retailer;
    const params = {
      ...parameters,
      retailerId,
    };

    dispatch(fetchRetailerReportsRequest());

    const { content, ...pagination } = await api.fetchRetailerReports(params);
    const items = content.map((report) => {
      const { contentId, created, retailerId, fileType, configuredReportName } = report;
      const { fileTypeTranslationsDto, transformations } = fileType;
      const availableTransitions = transformations ? transformations.filter((transition) => transition.enabled) : [];
      const fileName = fileTypeTranslationsDto ? fileTypeTranslationsDto[locale].fileDisplayNm : '';
      const customFileName = configuredReportName != "" ? configuredReportName : createCustomFileName(fileName, created, retailerDisplayNumber, dateFormatShort);
      const downloadData = availableTransitions.map((transition) => ({
        extension: transition.transformType,
        customFileName,
        fileName,
        contentId,
        retailerId,
      }));

      return {
        contentId,
        created,
        retailerId,
        fileTypeTranslationsDto,
        downloadData,
      };
    });
    dispatch(fetchRetailerReportsSuccess(items, pagination));
  } catch (error) {
    dispatch(fetchRetailerReportsFailure());
    console.error('FETCH_RETAILER_REPORTS_FAILURE', error);
  }
};

export const clearFilters = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_RETAILER_REPORTS,
  });
};

export const downloadRetailerReportRequest = () => ({
  type: actionTypes.DOWNLOAD_RETAILER_REPORT_REQUEST,
});

export const downloadRetailerReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_RETAILER_REPORT_SUCCESS,
});

export const downloadRetailerReportFailure = () => ({
  type: actionTypes.DOWNLOAD_RETAILER_REPORT_FAILURE,
});

export const downloadRetailerReport =
  ({ filters, extension, contentId }) =>
  (dispatch, getState) => {
    try {
      const { session } = getState();
      const retailerId = filters.retailerId || session.retailer.retailerId;
      const requestParams = {
        id: contentId,
        ...filters,
        retailerId,
        extension,
      };

      dispatch(downloadRetailerReportRequest());
      dispatch(downloadRetailerReportSuccess());
      return api.downloadRetailerReport(requestParams);
    } catch (error) {
      console.error('DOWNLOAD_RETAILER_REPORT', error);
      dispatch(downloadRetailerReportFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/actions/retailer-reports.actions.js